import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;

  var getSlideIndex = function getSlideIndex(index) {
    var slideIndex = index;

    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      // eslint-disable-next-line
      slideIndex = slideIndex - slides.length;
    }

    return slideIndex;
  };

  var style = swiper.isHorizontal() ? _defineProperty({}, swiper.rtlTranslate ? 'right' : 'left', "".concat(virtualData.offset, "px")) : {
    top: "".concat(virtualData.offset, "px")
  };
  var from = virtualData.from,
      to = virtualData.to;
  var loopFrom = swiper.params.loop ? -slides.length : 0;
  var loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  var slidesToRender = [];

  for (var i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }

  return slidesToRender.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      style: style,
      key: "slide-".concat(index)
    });
  });
}

export { renderVirtual };